import { RECORD_TYPE } from 'LixaniAPI/enums';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectPersonalWorkAndBreakRecordsFromToday } from 'scenes/WorkDemo/store/selectors/personalWorkCalendar.selectors';
import { selectPersonalRecordProjectsFromToday } from 'store/records/selectors/records.selectors';
import { RecordsTimelineWorkRecords } from './RecordsTimeLineWorkRecords';
import { RecordsTimelineBreaks } from './RecordTimelineBreaks';
import { RecordsTimelineRides } from './RecordTimelineRides';

export function RecordsTimelineProjects({ currentDate }) {
  const projectsOfRecordsOfTheDay = useSelector(
    selectPersonalRecordProjectsFromToday
  );

  const recordsFromToday = useSelector(
    selectPersonalWorkAndBreakRecordsFromToday
  );

  const workRecords = [];

  const breakRecords = [];

  const rideRecords = [];

  recordsFromToday.forEach((record) => {
    if (
      record.type === RECORD_TYPE.WORK ||
      record.type === RECORD_TYPE.PROJECTWORK
    ) {
      workRecords.push(record);
    } else if (
      [
        RECORD_TYPE.BREAK,
        RECORD_TYPE.BREAK_COFFEE,
        RECORD_TYPE.BREAK_MEAL,
      ].includes(record.type)
    ) {
      breakRecords.push(record);
    } else if (record.type === RECORD_TYPE.RIDE) {
      rideRecords.push(record);
    }
  });

  return projectsOfRecordsOfTheDay.map((project) => {
    const workRecordsByProject = workRecords.filter(
      (record) => record.project === project.id
    );
    const breakRecordsByProject = breakRecords.filter(
      (record) => record.project === project.id
    );

    const rideRecordsByProject = rideRecords.filter(
      (record) => record.project === project.id
    );

    return (
      <svg key={`timeline-project-${project.id}`} width={650} height="40px">
        <RecordsTimelineWorkRecords
          projectName={project.name ? project.name : ''}
          currentDate={currentDate}
          workRecords={workRecordsByProject}
        ></RecordsTimelineWorkRecords>
        <RecordsTimelineBreaks
          breakRecords={breakRecordsByProject}
          currentDate={currentDate}
        ></RecordsTimelineBreaks>
        <RecordsTimelineRides
          rideRecords={rideRecordsByProject}
          currentDate={currentDate}
        ></RecordsTimelineRides>
      </svg>
    );
  });
}
